import * as color_ from './color'

export * from './color'
export * from './icons'
export * from './layout'
export * from './typeface'
export * from './loader'

export const color = color_
